import React, { Component } from "react";
import { connect } from "react-redux";
import {
  retrieveRemorques,
  findRemorquesByTitle,
  deleteAllRemorques,
} from "../actions/remorques";
import { Link } from "react-router-dom";

class RemorquesList extends Component {
  constructor(props) {
    super(props);
    this.onChangeSearchNom = this.onChangeSearchNom.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.setActiveRemorque = this.setActiveRemorque.bind(this);
    this.findByNom = this.findByNom.bind(this);
    this.removeAllRemorques = this.removeAllRemorques.bind(this);

    this.state = {
      currentRemorque: null,
      currentIndex: -1,
      searchNom: "",
    };
  }

  componentDidMount() {
    this.props.retrieveRemorques();


  }

  onChangeSearchNom(e) {
    const searchNom = e.target.value;

    this.setState({
      searchNom: searchNom,
    });
  }

  refreshData() {
    this.setState({
      currentRemorque: null,
      currentIndex: -1,
    });
  }

  setActiveRemorque(remorque, index) {
    this.setState({
      currentRemorque: remorque,
      currentIndex: index,
    });
  }

  removeAllRemorques() {
    this.props
      .deleteAllRemorques()
      .then((response) => {
        console.log(response);
        this.refreshData();
      })
      .catch((e) => {
        console.log(e);
      });
  }

  findByNom() {
    this.refreshData();

    this.props.findRemorquesByTitle(this.state.searchNom);
  }

  render() {
    const { searchNom, currentRemorque, currentIndex } = this.state;
    const { remorques } = this.props;
    console.log(this.props);


    return (
      <div className="list row">
        <div className="col-md-8">
          <div className="input-group mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Rechercher une remorque"
              value={searchNom}
              onChange={this.onChangeSearchNom}
            />

            <div className="input-group-append">
              <button
                className="btn btn-outline-secondary"
                type="button"
                onClick={this.findByNom}
              >
                Rechercher
              </button>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <h4>Liste des remorques</h4>

          <ul className="list-group">
            {remorques &&
            remorques.map((remorque, index) => (

                <li
                    className={
                      "list-group-item " +
                      (index === currentIndex ? "active" : "")
                    }

                    onClick={() => this.setActiveRemorque(remorque)}
                    key={remorque.id}

                >
                  <ul>{remorque.Nom}
                  </ul>
                  <tr>
                    <td><img className="img" src={remorque.Img1} alt={remorque.Img1}/></td>
                    <td><img className="img" src={remorque.Img2} alt={remorque.Img2}/></td>
                    <td><img className="img" src={remorque.Img3} alt={remorque.Img3}/></td>
                  </tr>
                </li>


            ))}
          </ul>

          <button
            className="m-3 btn btn-sm btn-danger"
            onClick={this.removeAllRemorques}
          >
            Supprimer toutes les remorques
          </button>
        </div>
        <div className="col-md-6">
          {currentRemorque ? (
            <div>
              <h4>Remorques</h4>
              <div>
                <label>
                  <strong>Nom:</strong>
                </label>{" "}
                {currentRemorque.Nom}
              </div>
              <div>
                <label>
                  <strong>Status:</strong>
                </label>{" "}
                {currentRemorque.published ? "Published" : "Pending"}
              </div>

              <Link
                to={"/remorques/" + currentRemorque.id}
                className="badge badge-warning"
              >
                Editer
              </Link>
            </div>
          ) : (
            <div>
              <br />
              <p>Cliquez sur une remorque ou  </p>
              <p><a href="https://gestion.attirail.fr/addremorques"> Ajouter une remorque</a> </p>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    remorques: state.remorques,
  };
};

export default connect(mapStateToProps, {
  retrieveRemorques,
  findRemorquesByTitle,
  deleteAllRemorques,
})(RemorquesList);
